import React from 'react';
import { useLang } from '../context/LanguageContext';
import PageHero from '../components/PageHero';
import CTASection from '../components/CTASection';
import { Cpu, Palmtree, Leaf, HeartPulse, Factory, Building2, GraduationCap, Landmark } from 'lucide-react';

const icons = [Cpu, Palmtree, Leaf, HeartPulse, Factory, Building2, GraduationCap, Landmark];

const Opportunities = () => {
  const { t } = useLang();
  return (
    <div>
      <PageHero title={t.opportunities.title} desc={t.opportunities.desc} />
      <section className="bg-[#FBF9F2] py-20">
        <div className="sib-container">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
            {t.opportunities.sectors.map((s, i) => {
              const Icon = icons[i] || Cpu;
              return (
                <div key={i} className="bg-white border border-[#E8E1CE] rounded-lg p-6 card-hover">
                  <div className="w-12 h-12 rounded-md bg-[#D4A840]/15 flex items-center justify-center mb-4"><Icon className="w-6 h-6 text-[#D4A840]" /></div>
                  <h3 className="font-semibold text-[#0B5D3B] mb-2 text-[16px]">{s.title}</h3>
                  <p className="text-[13.5px] text-[#33473d]/80 leading-relaxed">{s.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <CTASection />
    </div>
  );
};
export default Opportunities;
